<form class="modal-form" [formGroup]="form" (ngSubmit)="submit()">
	<ng-content></ng-content>
	<div class="form-footer">
		@if (isShowSubmit) {
			<ea-button
				[type]="submitButtonType"
				[isSubmit]="true"
				[isSubmitting]="isSubmitting"
				name="{{ name }}ModalSubmit"
				[isDisabled]="form.invalid && !enableSubmitButton"
			>
				{{ submitLabel }}
			</ea-button>
		}
		@if (isShowCancel) {
			<ea-button
				(click)="handleModalFormCancel()"
				name="{{ name }}ModalCancel"
				[type]="cancelButtonType"
			>
				{{ cancelLabel }}
			</ea-button>
		}
		<ng-content select="form-footer-content"></ng-content>
	</div>
</form>
